<template>
  <div>
    <ul class="navbar-nav">
      <template v-for="menu in menus">
        <template v-if="menu.children.length > 0">
          <v-menu open-on-hover offset-y v-bind:key="menu.id">
            <template v-slot:activator="{ on }">
              <router-link tag="li" :to="link(menu)" :key="menu.id">
                <a v-on="on" href="#">{{ menu.title }}</a>
              </router-link>
            </template>
            <v-list class="dropdown-menu">
              <v-list-item
                v-for="children in menu.children"
                :key="children.id"
              >
                <router-link tag="li" :to="link(children)" :key="children.id">
                  <a href="#">{{ children.title }}</a>
                </router-link>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-else>
          <router-link tag="li" :to="link(menu)" :key="menu.id">
            <a href="#">{{ menu.title }}</a>
          </router-link>
        </template>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    menus: [Array, Object]
  },
  data: () => ({
  }),
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  mounted () {
  },
  methods: {
    link (menu) {
      switch (menu.view) {
        case 'page':
          return '/article/' + menu.slug
        case 'page_blog':
          return '/blog/' + menu.slug
        case 'ahchor':
          return '#'
        case 'url':
          return '/' + menu.url
        default:
          return '#'
      }
    }
  }
}
</script>
